import { useState } from 'react';
import {
  CasRenderArrayAsRows,
  CasTable,
  CasErrorDisplay,
} from 'src/compass/shared/components';
import CasLoader from 'src/compass/shared/components/CasLoader/CasLoader';
import { useCurrentUserEmployee, CasYesNoSelect } from 'src/compass/application';

import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import CustomerDialog from './CustomerDialog';
import { RenderRiskManagerName } from './RenderRiskManagerName';
import RenderHandoff from './RenderHandoff';
// import RenderRMCOfRecord from './RenderRMCOfRecord'; // RMC of Record column hidden for now
import { TOUCHPOINT_ENTITY } from './TouchpointsTab';

export default function HandoffsTab() {
  const [dialogRowId, setDialogRowId] = useState<number | null>(null);
  const [reloadTable, setReloadTable] = useState<Date | null>(null);

  const { data, isLoading, isError, error } = useCurrentUserEmployee();

  if (isLoading) return <CasLoader />;
  if (isError) return <CasErrorDisplay message={error.message} />;

  return (
    <>
      <CasTable
        entity={TOUCHPOINT_ENTITY}
        includeExport={false}
        refreshBtn
        update={reloadTable}
        additionalPayload={{ employeeId: data?.employeeId }}
        columns={[
          {
            field: 'name',
            render: (props: ICasRenderCellProps) => (
              <RenderRiskManagerName {...props} onClick={setDialogRowId} />
            ),
          },
          {
            field: 'contacts',
            sortable: false,
            render: CasRenderArrayAsRows,
          },
          // RMC of Record column hidden for now
          // {
          //   field: 'isRMCOfRecord',
          //   label: 'RMC of Record?',
          //   sortable: false,
          //   render: RenderRMCOfRecord,
          // },
          {
            field: 'handoff',
            label: 'Handoff',
            sortable: false,
            render: ({ row }: ICasRenderCellProps) => (
              <RenderHandoff
                id={row.id}
                handoffRequested={row.handoffRequested}
                handoffRequestedByName={row.handoffRequestedByName}
                handoffRequestedByCurrentUser={row.handoffRequestedByCurrentUser}
              />
            ),
          },
        ]}
        filters={[
          {
            name: 'searchName',
            label: 'Name',
          },
          {
            type: 'component',
            name: 'shared',
            label: 'Shared',
            initialValue: true,
            includeAllOption: true,
            component: CasYesNoSelect,
          },
          // RMC of Record filter hidden for now
          // {
          //   type: 'component',
          //   name: 'isRMCOfRecord',
          //   label: 'RMC of Record?',
          //   includeAllOption: true,
          //   component: CasYesNoSelect,
          // },
          {
            type: 'component',
            name: 'handoffRequested',
            label: 'Handoff Requested',
            includeAllOption: true,
            component: CasYesNoSelect,
          },
        ]}
      />
      {dialogRowId && (
        <CustomerDialog
          id={dialogRowId}
          onClose={(dataUpdated?: boolean) => {
            setDialogRowId(null);
            if (dataUpdated) setReloadTable(new Date());
          }}
        />
      )}
    </>
  );
}
